import { EuiSuperSelectOption } from "@inscopix/ideas-eui";
import { FieldDefaultFormula } from "./FieldDefaultFormula";
import { DataTableColumnDefinition } from "pages/gdt/store/DataTableProvider.types";
import { SuperSelectPermissioned } from "components/SuperSelectPermissioned/SuperSelectPermissioned";

interface FieldDefaultFormulaChoiceProps {
  autoFocus?: boolean;
  disabled?: boolean;
  choices: Extract<DataTableColumnDefinition, { kind: "choice" }>["choices"];
  value: string | undefined;
  onChange: (field: { value: string | undefined; isValid: boolean }) => void;
}

export const FieldDefaultFormulaChoice = ({
  autoFocus,
  disabled,
  choices,
  value,
  onChange,
}: FieldDefaultFormulaChoiceProps) => {
  const options: EuiSuperSelectOption<string>[] = choices.map((choice) => ({
    value: choice.value.toString(),
    inputDisplay: choice.label,
  }));

  const handleChange = (newValue: string) => {
    if (newValue === value?.toString()) {
      onChange({
        value: undefined,
        isValid: true,
      });
    } else {
      onChange({
        value: newValue,
        isValid: true,
      });
    }
  };

  return (
    <FieldDefaultFormula>
      <SuperSelectPermissioned
        requiredPermission="edit"
        fullWidth
        options={options}
        valueOfSelected={value?.toString()}
        onChange={handleChange}
        placeholder="None"
        autoFocus={autoFocus}
        disabled={disabled}
      />
    </FieldDefaultFormula>
  );
};
